import { render, staticRenderFns } from "./PIrecordModel.vue?vue&type=template&id=22bc3d3b&scoped=true"
import script from "./PIrecordModel.vue?vue&type=script&lang=js"
export * from "./PIrecordModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc3d3b",
  null
  
)

export default component.exports